module.exports = __webpack_public_path__ + "f65eaf6e4658743111c436b09bfb2b8e.svg";